module.exports = __webpack_public_path__ + "static/img/taimajiang.dd8f161.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/taimajiang.jpg
// module id = Wjjm
// module chunks = 0